import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { api } from 'lib/httpClient';
import qs from 'qs';

async function fetchInvestmentInflowSummary({ queryKey }) {
  const [, firmId, dateRangeKey, fundTagIds] = queryKey;
  const queryParams = qs.stringify({ ...(firmId && { firmId }), fundTagIds });

  const url = `dashboard/investments-inflow-summary/${dateRangeKey}?${queryParams}`;

  const { data } = await api.get(url);

  return data.data;
}

function useInvestmentInflowSummary({ firmId, dateRangeKey, fundTagIds }) {
  return useQuery({
    queryKey: ['investment-inflow-summary', firmId, dateRangeKey, fundTagIds],
    queryFn: fetchInvestmentInflowSummary,
    placeholderData: keepPreviousData,
    staleTime: 4 * 60 * 60 * 1000,
  });
}

export default useInvestmentInflowSummary;
